module.exports = __webpack_public_path__ + "img/IMG_1627_Foamcore_MockedUp.844628cf.jpg";